import React, { useState } from 'react';
import '../styles/CheckboxExample.css';

const learningInterests = [
  {
    id: 'python',
    label: 'Python Programming',
    description: 'Fundamentals, OOP, and real-world coding projects',
  },
  {
    id: 'selenium',
    label: 'Web Automation with Selenium',
    description: 'UI testing with Java, TestNG, and framework design',
  },
  {
    id: 'api-testing',
    label: 'API Testing',
    description: 'REST APIs, status codes, authentication, and validation',
  },
  {
    id: 'generative-ai',
    label: 'Generative AI & Prompt Engineering',
    description: 'ChatGPT, Gemini, Claude, and practical AI workflows',
  },
];

const CheckboxExample = () => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleCheckboxChange = (optionId) => {
    if (selectedOptions.includes(optionId)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== optionId));
    } else {
      setSelectedOptions([...selectedOptions, optionId]);
    }
  };

  return (
    <div className="checkbox-example">
      <h2 className="checkbox-heading">Checkboxes</h2>
      <p className="checkbox-description">
        Select the learning topics you are interested in. You can choose one or more options.
      </p>

      <form className="checkbox-group" id="checkboxes">
        {learningInterests.map((option) => (
          <label key={option.id} htmlFor={`checkbox-${option.id}`} className="checkbox-item">
            <input
              type="checkbox"
              id={`checkbox-${option.id}`}
              className="checkbox"
              checked={selectedOptions.includes(option.id)}
              onChange={() => handleCheckboxChange(option.id)}
            />
            <span className="checkbox-content">
              <span className="checkbox-label">{option.label}</span>
              <span className="checkbox-help">{option.description}</span>
            </span>
          </label>
        ))}
      </form>

      {selectedOptions.length > 0 && (
        <p className="checkbox-selection-summary" id="checkbox-selection-summary">
          Selected: {selectedOptions.length} topic{selectedOptions.length > 1 ? 's' : ''}
        </p>
      )}
    </div>
  );
};

export default CheckboxExample;
